import { VISITOR_STATUS_LABELS } from "./visitorStatuses";

/** Resolve status label from API row (status_id, out_time, is_inside, backend `status`). */
export function resolveVisitorStatus(visitor) {
  if (!visitor) return "";

  if (visitor.status_id === 1 || visitor.status_id === "1") {
    return VISITOR_STATUS_LABELS.INSIDE;
  }
  if (visitor.status_id === 0 || visitor.status_id === "0") {
    return VISITOR_STATUS_LABELS.COMPLETED;
  }

  if (visitor.status) {
    const s = String(visitor.status);
    if (s === VISITOR_STATUS_LABELS.INSIDE || s === VISITOR_STATUS_LABELS.COMPLETED) {
      return s;
    }
  }

  const inside =
    visitor.is_inside === 1 ||
    visitor.is_inside === true ||
    String(visitor.is_inside) === "1";

  if (inside && !visitor.out_time) {
    return VISITOR_STATUS_LABELS.INSIDE;
  }
  if (visitor.out_time || visitor.is_inside === 0 || String(visitor.is_inside) === "0") {
    return VISITOR_STATUS_LABELS.COMPLETED;
  }
  return VISITOR_STATUS_LABELS.PENDING_EXIT;
}

export function isVisitorInside(visitor) {
  return resolveVisitorStatus(visitor) === VISITOR_STATUS_LABELS.INSIDE;
}
